/**
 * Sanitizes HTML content by removing unwanted inline styles
 * that might interfere with our custom styling
 */
export const sanitizeHtmlContent = (htmlString) => {
  if (!htmlString) return '';

  // Create a temporary DOM element to parse the HTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;

  // Remove inline styles that might override our CSS
  const elementsWithStyle = tempDiv.querySelectorAll('[style]');
  elementsWithStyle.forEach((element) => {
    // Remove specific problematic styles but keep safe ones
    const style = element.getAttribute('style');
    if (style) {
      // Remove background and color related styles
      const cleanedStyle = style
        .split(';')
        .filter((s) => {
          const trimmed = s.trim().toLowerCase();
          return (
            !trimmed.startsWith('background') &&
            !trimmed.startsWith('color') &&
            trimmed !== ''
          );
        })
        .join(';');

      if (cleanedStyle) {
        element.setAttribute('style', cleanedStyle);
      } else {
        element.removeAttribute('style');
      }
    }
  });

  return tempDiv.innerHTML;
};
